import { TrackerEvent } from './tracker-event';
import { createTrackReplayer } from './util';
import { loadScript } from '@fastcampus/browser-util';

const SCRIPT_URL = '//wcs.naver.net/wcslog.js';

const INFLOW_DOMAIN = 'fastcampus.co.kr';

/** @enum {string} 전환 유형 */
const ConversionType = {
  PAYMENT: '1', // 구매완료 페이지
  SIGNUP: '2', // 회원가입 완료 페이지
  CART: '3', // 장바구니 페이지
  LEAD: '4', // 신청/예약 완료 페이지
  ETC: '5', // 기타 페이지
};

/** 전환 가치 기본값(전환 유형=1이 아니고 추정 불가능할 경우에만 사용) */
const DEF_CONVERSION_VALUE = '1';

/**
 * @see www/views/_partials/_tracker_naver.html
 * @see https://saedu.naver.com/help/faq/ncc/view.nhn?faqSeq=128
 */
export class NaverTracker {
  static create(opts, context) {
    return new NaverTracker(opts, context);
  }

  constructor({ id, userId }, context) {
    this.id = id;
    this.userId = userId;
    this.name = 'naver';

    if (!context.wcs_add) context.wcs_add = {};
    context.wcs_add['wa'] = this.id;
    loadScript(SCRIPT_URL)
      .then(() => {
        if (!context._nasa) context._nasa = {};
        context.wcs.inflow(INFLOW_DOMAIN);
        context.wcs_do();
        // 스크립트 로딩 후에 이벤트를 보내야 함!
        this._track = (event, value = DEF_CONVERSION_VALUE) => {
          if (event) {
            context._nasa['cnv'] = context.wcs.cnv(event, value);
          }
          // 네이버 트래커는 숨겨진 이미지 하나씩 추가하면서 img src 파라메터로 트래킹 정보 보내는 방식
          context.wcs_do(context._nasa);
        };
        this.ready = true;
      })
      .catch((err) => {
        console.error('install err!', err);
      });
  }

  track(event, data) {
    if (!this.ready) {
      if (process.env['NODE_ENV'] !== 'prod') console.error('**ignore** not ready!', event, data);
      const trackReplayer = createTrackReplayer({ target: this, time: 3 });
      trackReplayer(event, data);
      return;
    }
    switch (event) {
      case TrackerEvent.PAGE_VIEW:
        break;
      case TrackerEvent.USER_SIGNUP:
        this._track(ConversionType.SIGNUP);
        break;
      case TrackerEvent.USER_LOGIN:
        break;
      case TrackerEvent.FORMAT_VIEW:
        break;
      case TrackerEvent.CATEGORY_VIEW:
        break;
      case TrackerEvent.COURSE_VIEW:
        break;
      case TrackerEvent.ENROLLMENT_VIEW:
        break;
      case TrackerEvent.ENROLLMENT_PENDING:
        this._track(ConversionType.LEAD);
        break;
      case TrackerEvent.TRANSACTION_ORDER:
        break;
      case TrackerEvent.TRANSACTION_PAYMENT:
        if (data) {
          const { transactionInfo } = data;
          const amount = transactionInfo && transactionInfo.transaction && transactionInfo.transaction.amount;
          this._track(ConversionType.PAYMENT, amount);
        }
        break;
      case TrackerEvent.COMMON: {
        break;
      }
    }
  }
}
